import { Traveler2, TravelerRole } from '~/models/Traveler'
import { APITraveler } from './apiType'

export class TravelerEntityMapper {
	static toTravelers(travelers: APITraveler[]): Traveler2[] {
		return travelers.map((traveler: APITraveler) => this.toTraveler(traveler))
	}

	static toTraveler(traveler: APITraveler): Traveler2 {
		return {
			id: traveler.user_id,
			name: traveler.name,
			username: traveler.username,
			role: traveler.role as TravelerRole,
			picture: traveler.picture,
		}
	}
}
